import * as Yup from 'yup';
var schema = function schema(fields, yupSchema, yupSchemaOnly) {
  var form = {};
  var validateField = function validateField(field, type) {
    var validator = null;
    var fieldId = "input_".concat(field.id).replace(/\./g, '_');
    if (yupSchema[fieldId]) {
      validator = yupSchema[fieldId];
    } else if (type === 'consent') {
      validator = Yup.boolean().oneOf([true], field.errorMessage || 'consent').required(field.errorMessage || 'consent');
    } else if (type === 'list') {
      validator = Yup.array();
      // fieldId = `${fieldId}_1`
      if (field.isRequired) {
        if (field.conditionalLogic) {
          field.conditionalLogic.rules.forEach(function (rule) {
            var conditionFieldId = "input_".concat(rule.fieldId);
            var conditionValue = rule.value;
            if (rule.operator === 'IS') {
              validator = validator.when(conditionFieldId, {
                is: function is(val) {
                  return val === conditionValue;
                },
                then: Yup.array().min(1, field.errorMessage || 'required'),
                otherwise: Yup.array()
              });
            }
            if (rule.operator === 'IS_NOT') {
              validator = validator.when(conditionFieldId, {
                is: function is(val) {
                  return val === conditionValue;
                },
                then: Yup.array(),
                otherwise: Yup.array().min(1, field.errorMessage || 'required')
              });
            }
          });
        } else {
          validator = validator.min(1, field.errorMessage || 'required');
        }
      }
    } else if (['checkbox', 'multiselect'].indexOf(type) === -1) {
      validator = Yup.string();
      if (field.isRequired) {
        if (field.conditionalLogic) {
          field.conditionalLogic.rules.forEach(function (rule) {
            var conditionFieldId = "input_".concat(rule.fieldId);
            var conditionValue = rule.value;
            if (rule.operator === 'IS') {
              validator = validator.when(conditionFieldId, {
                is: function is(val) {
                  return val === conditionValue;
                },
                then: Yup.string().required(field.errorMessage || 'required'),
                otherwise: Yup.string().notRequired()
              });
            }
            if (rule.operator === 'IS_NOT') {
              validator = validator.when(conditionFieldId, {
                is: function is(val) {
                  return val === conditionValue;
                },
                then: Yup.string().notRequired(),
                otherwise: Yup.string().required(field.errorMessage || 'required')
              });
            }
          });
        } else {
          validator = validator.required(field.errorMessage || 'required');
        }
      }
      if (type === 'email') {
        validator = validator.email(field.errorMessage || 'Vul een geldig e-mailadres in');
      }
      if (type === 'website') {
        validator = validator.url(field.errorMessage || 'Vul een geldige URL in');
      }
    } else if (field.isRequired) {
      validator = Yup.string().required(field.errorMessage || 'required');
    }
    if (validator) form[fieldId] = validator;
  };
  if (yupSchemaOnly) {
    return Yup.object().shape(yupSchema);
  }
  fields.forEach(function (field) {
    var type = field.type.toLowerCase();
    if (type === 'name') {
      field.inputs.forEach(function (input) {
        if (!input.isHidden) {
          validateField(input, type);
        }
      });
    } else {
      validateField(field, type);
    }
  });
  return Yup.object().shape(form);
};
export default schema;